import { Check } from "lucide-react";
import Header from "../components/Header";
import Offertetwee from "../components/Offertetwee";
import PartnerMarquee from "../components/PartnerMarquee";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";
import OfferteFAQ from "../components/OfferteFAQ";
import Footer from "../components/Footer";
function Offerte() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Gratis offerte - Elektraaanleggen.nl"
        description="Ontvang snel een vrijblijvende offerte voor al je elektra-installaties. Vul je gegevens in en wij zorgen voor een scherpe prijs en professionele service!"
        schema={generateServiceSchema({
          name: "Gratis offerte",
          description:
            "Vraag eenvoudig een gratis en vrijblijvende offerte aan voor jouw elektra-project. Onze gecertificeerde experts bieden je een scherpe prijs en professionele uitvoering.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />
      <Header />
      <div className="relative grid grid-cols-1 w-full md:grid-cols-[1fr_auto] pt-16 md:pt-[55px] bg-gray-50">
        <div className="absolute w-full h-[510px] overflow-hidden bg-[#2FB6D2]">
          <div className="relative w-full h-[510px]">
            <div className="absolute -bottom-[1px] z-[3] left-1/2 -translate-x-1/2">
              <svg
                width="3840"
                height="327"
                viewBox="0 0 3840 327"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 0.136719V326.999H3840V0.136719C3840 0.136719 3128.32 302.999 1920 302.999C711.68 302.999 0 0.136719 0 0.136719Z"
                  fill="#f9fafb"
                />
              </svg>
            </div>
          </div>
        </div>
        <section className="mx-auto w-[calc(100%-2.5rem)] gap-x-6 gap-y-3 max-w-[1260px] grid mb-16 md:mb-24 grid-rows-[auto_1.8fr] md:grid-rows-none md:grid-cols-[1fr_1.8fr]">
          <div className="grid place-content-center row-[2] z-[4] md:place-content-start md:w-[448px] md:col-[1] md:row-[1] order-1">
            <Offertetwee />
          </div>
          <ul className="space-y-3 mb-6 relative z-20 bg-white p-3 rounded-lg h-fit w-fit mt-2">
            <li className="flex items-center gap-2">
              <Check className="w-5 h-5 text-[#F47B20]" />
              <span className="text-[#17354A]">
                <strong>Gratis</strong> advies &{" "}
                <strong>offerte binnen 24 uur</strong>
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="w-5 h-5 text-[#F47B20]" />
              <span className="text-[#17354A]">
                <strong>Gecertificeerde</strong> & InstalQ-geregistreerde
                elektriciens
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="w-5 h-5 text-[#F47B20]" />
              <span className="text-[#17354A]">
                Vaste prijs vooraf, <strong>geen verrassingen</strong>
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="w-5 h-5 text-[#F47B20]" />
              <span className="text-[#17354A]">
                Snelle installatie, vaak binnen 1 werkdag
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="w-5 h-5 text-[#F47B20]" />
              <span className="text-[#17354A]">
                8 jaar <strong>garantie</strong> op materiaal & installatie
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="w-5 h-5 text-[#F47B20]" />
              <span className="text-[#17354A]">
                Zegelgerechtigde elektriciens
              </span>
            </li>
          </ul>
        </section>
      </div>
      <PartnerMarquee />
    </div>
  );
}
export default Offerte;
